/**
 * Injects FAQPage JSON-LD into `<head>` from FAQ entries in `platformCopy.json`
 * that have `includeInJsonLd` and `schemaAnswer`. Call on the homepage where
 * the FAQ section is rendered. Removes the script on unmount.
 */
import { useEffect } from "react";
import { JSON_LD_FAQ } from "../constants/platformCopy";

const JSON_LD_SCRIPT_ID = "jigsawml-faq-ld";

export function useJsonLdFaq(): void {
  useEffect(() => {
    if (JSON_LD_FAQ.length === 0) {
      return;
    }

    const script = document.createElement("script");
    script.id = JSON_LD_SCRIPT_ID;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: JSON_LD_FAQ.map(({ question, answer }) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: {
          "@type": "Answer",
          text: answer,
        },
      })),
    });
    document.head.appendChild(script);

    return () => {
      document.getElementById(JSON_LD_SCRIPT_ID)?.remove();
    };
  }, []);
}
